import { createAction } from '@ngrx/store';

const enum TripDetailsActionTypes {
  tripDetailsPayBalance = '[trip-details] PAY_BALANCE',
}

export const tripDetailsPayBalance = createAction(
  TripDetailsActionTypes.tripDetailsPayBalance,
);
